export class SerieEscolar {

    id: number;
    descricao: string;
}